import { render, staticRenderFns } from "./wjscDialog.vue?vue&type=template&id=17a92e2a&"
import script from "./wjscDialog.vue?vue&type=script&lang=js&"
export * from "./wjscDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports